import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { ApiService } from '../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';

const CategoryDetail = () => {
    const { categoryUrl, subcategoryUrl } = useParams();
    const [categoryDetail, setCategoryDetail] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCategoryDetailData = async () => {
            const urlParam = categoryUrl || subcategoryUrl;

            if (!urlParam) {
                console.error('No category or subcategory URL provided');
                setLoading(false);
                return;
            }

            try {
                const endpoint = categoryUrl
                    ? `menu/${categoryUrl}`
                    : `product/${subcategoryUrl}`;

                const response = await ApiService.Commanfetchrequest(endpoint);
                console.log('API Response:', response);

                if (response && response.categoryDetail) {
                    setCategoryDetail(response.categoryDetail);
                } else {
                    console.error('No category data available in response.');
                }
            } catch (error) {
                console.error('Error fetching category details:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategoryDetailData();
    }, [categoryUrl, subcategoryUrl]);

    return (
        <>
            <Header />
            <div className="category-detail mt-5 py-5">
                <div className="container mt-3">
                    {loading ? (
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 text-center">
                                <Skeleton width={500} height={300} />
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <h3 className="category-title"><Skeleton width={150} height={20} /></h3>
                                <p className="category-desc"><Skeleton width={500} height={200} /></p>
                                <Skeleton width={110} height={40}/>
                            </div>
                        </div>
                    ) : (
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 text-center">
                                <img
                                    src={`https://sigohrmlpadmin.loopring.in/front/images/categories/${categoryDetail?.category_image}`}
                                    alt={categoryDetail?.category_name}
                                    className="img-fluid category-img"
                                />
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <h3 className="category-title" style={{color:"green"}}>{categoryDetail?.category_name}</h3>
                                <p className="category-desc" dangerouslySetInnerHTML={{ __html: categoryDetail?.description }}></p>
                                <Link to="/start-free-trial">
                                    <button className='btn btn-primary'>Get Started</button>
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default CategoryDetail;
